
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/daftar",
      function () {
        return require("private-next-pages/daftar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/daftar"])
      });
    }
  